<template>
<div>
    <div v-if="ie=='i'">
        <!-- 乌干达(UGA)进口提单明细 -->
        <el-card class="partItem">
            <table>
                <tbody>
                    <tr>
                        <th width="25%">出口国代码</th>
                        <td width="25%">{{billInfo.CountryCode}}</td>
                        <th width="25%">数量单位</th>
                        <td width="25%">{{billInfo.QuantityUnit}}</td>
                    </tr>
                    <tr>
                        <th>毛重</th>
                        <td>{{billInfo.Weight}}</td>
                        <th>净重</th>
                        <td>{{billInfo.NetWeight}}</td>
                    </tr>
                    <tr>
                        <th>海关金额（美金）</th>
                        <td>{{billInfo.Value}}</td>
                        <th>海关金额（乌干达金额）</th>
                        <td>{{billInfo.UgxOfCifValue}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>

        <el-card class="partItem">
            <div slot="header">
                <span class="headTitle">运输信息</span>
            </div>
            <table>
                <tbody>
                    <tr>
                        <th>原产国</th>
                        <td colspan="3">{{billInfo.Country}}</td>
                    </tr>
                    <tr>
                        <th width="25%">出口国</th>
                        <td width="25%">{{billInfo.ExportCountry}}</td>
                        <th width="25%">出口国代码</th>
                        <td width="25%">{{billInfo.CountryCode}}</td>
                    </tr>
                    <tr>
                        <th>目的国</th>
                        <td>{{billInfo.DestinationCountry}}</td>
                        <th>目的国代码</th>
                        <td>UG</td>
                    </tr>
                    <tr>
                        <th>税(乌干达金额)</th>
                        <td>{{billInfo.TaxAmount}}</td>
                        <th>税(美金)</th>
                        <td>{{billInfo.TaxAmountUSD}}</td>
                    </tr>
                    <tr>
                        <th>纳税人</th>
                        <td>{{billInfo.TaxpayerName}}</td>
                        <th>纳税人识别号</th>
                        <td>{{billInfo.TaxpayerTin}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>
    </div>
    <div v-if="ie=='e'">
        <!-- 乌干达(UGA)出口提单明细 -->
        <el-card class="partItem">
            <table>
                <tbody>
                    <tr>
                        <th width="25%">出口商ID</th>
                        <td width="25%">{{billInfo.ExporterId}}</td>
                        <th width="25%">出口国</th>
                        <td width="25%">{{billInfo.ExportCountry}}</td>
                    </tr>
                    <tr>
                        <th>出口国代码</th>
                        <td>UG</td>
                        <th>数量单位</th>
                        <td>{{billInfo.QuantityUnit}}</td>
                    </tr>
                    <tr>
                        <th>毛重</th>
                        <td>{{billInfo.Weight}}</td>
                        <th>净重</th>
                        <td>{{billInfo.NetWeight}}</td>
                    </tr>
                    <tr>
                        <th>海关金额（美金）</th>
                        <td>{{billInfo.Value}}</td>
                        <th>海关金额（乌干达金额）</th>
                        <td>{{billInfo.UgxOfCifValue}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>

        <el-card class="partItem">
            <div slot="header">
                <span class="headTitle">运输信息</span>
            </div>
            <table>
                <tbody>
                    <tr>
                        <th width="25%">原产国</th>
                        <td width="25%">{{billInfo.Country}}</td>
                        <th width="25%">出口国</th>
                        <td width="25%">{{billInfo.ExportCountry}}</td>
                    </tr>
                    <tr>
                        <th>目的国</th>
                        <td>{{billInfo.Country}}</td>
                        <th>目的国代码</th>
                        <td>{{billInfo.DestCountryCode}}</td>
                    </tr>
                    <tr>
                        <th>税(乌干达金额)</th>
                        <td>{{billInfo.TaxAmount}}</td>
                        <th>税(美金)</th>
                        <td>{{billInfo.TaxAmountUSD}}</td>
                    </tr>
                    <tr>
                        <th>纳税人</th>
                        <td>{{billInfo.TaxpayerName}}</td>
                        <th>纳税人识别号</th>
                        <td>{{billInfo.TaxpayerTin}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>
    </div>
</div>
</template>

<script>
export default {
    props:["billInfo","ie"],
    data() {
        return {

        };
    },
    methods: {
        
    },
    mounted() {

    },
};
</script>

<style lang="scss" scoped>
.partItem {
    margin-bottom: 20px;
    ::v-deep .el-card__header {
        padding: 10px 20px;
        .headTitle {
            display: inline-block;
            padding-left: 10px;
            font-size: 14px;
            border-left: 2px solid var(--themeColor);
            font-weight: bold;
        }
    }
}
table {
    width: 100%;
    border-collapse: collapse;
    tr {
        display: table-row;
        vertical-align: inherit;
        border-color: inherit;
        th,
        td {
            font-size: 12px;
            color: #666;
            height: 40px;
            border: 1px solid #eaeaea;
            text-align: center;
        }
        th {
            background-color: #f5f7fa;
            font-weight: 700;
        }
        .bg {
            background-color: var(--themeColor);
            color: #fff;
            font-weight: 700;
            opacity: 0.8;
        }
    }
}
</style>